import useChartColors from 'common/use-chart-colors';
import React from 'react'
import ReactApexChart from 'react-apexcharts';

const CustomRadial = ({ chartId }: any) => {
    const chartColors = useChartColors(chartId);

    const series = [76, 67, 61, 90];
    var options : any = {
        chart: {
            height: 390,
            type: 'radialBar',
        },
        plotOptions: {
            radialBar: {
                offsetY: 0,
                startAngle: 0,
                endAngle: 270,
                hollow: {
                    margin: 5,
                    size: '30%',
                    background: 'transparent',
                    image: undefined,
                },
                dataLabels: {
                    name: {
                        show: false,
                    },
                    value: {
                        show: false,
                    }
                }
            }
        },
        colors: chartColors,
        labels: ['Vimeo', 'Messenger', 'Facebook', 'LinkedIn'],
        legend: {
            show: true,
            floating: true,
            fontSize: '16px',
            position: 'left',
            offsetX: 160,
            offsetY: 15,
            labels: {
                useSeriesColors: true,
            },
            markers: {
                size: 0
            },
            formatter: function (seriesName: any, opts: any) {
                return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex]
            },
            itemMargin: {
                vertical: 3
            }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                legend: {
                    show: false
                }
            }
        }]
    };
    return (
        <React.Fragment>
            <ReactApexChart
                dir="ltr"
                options={options}
                series={series || []}
                data-chart-colors='["bg-custom-500", "bg-sky-500", "bg-green-500", "bg-purple-500"]'
                id={chartId}
                className="apex-charts"
                height={350}
                type="radialBar"
            />
        </React.Fragment>
    );
};

const GradientChart = ({ chartId }: any) => {
    const chartColors = useChartColors(chartId);

    const series = [75];
    var options : any = {
        chart: {
            height: 350,
            type: 'radialBar',
            toolbar: {
                show: true
            }
        },
        colors: chartColors,
        plotOptions: {
            radialBar: {
                startAngle: -135,
                endAngle: 225,
                hollow: {
                    margin: 0,
                    size: '70%',
                    image: undefined,
                    imageOffsetX: 0,
                    imageOffsetY: 0,
                    position: 'front',
                },
                track: {
                    strokeWidth: '67%',
                    margin: 0, // margin is in pixels
                },
    
                dataLabels: {
                    show: true,
                    name: {
                        offsetY: -10,
                        show: true,
                        fontSize: '17px'
                    },
                    value: {
                        formatter: function (val : any) {
                            return parseInt(val);
                        },
                        fontSize: '36px',
                        show: true,
                    }
                }
            }
        },
        fill: {
            type: 'gradient',
            gradient: {
                shade: 'dark',
                type: 'horizontal',
                shadeIntensity: 0.5,
                gradientToColors: [chartColors[1]],
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [0, 100]
            }
        },
        stroke: {
            lineCap: 'round'
        },
        labels: ['Percent'],
    };

    return (
        <React.Fragment>
            <ReactApexChart
                dir="ltr"
                options={options}
                series={series || []}
                data-chart-colors='["bg-custom-500", "bg-green-400"]'
                id={chartId}
                className="apex-charts"
                height={350}
                type="radialBar"
            />
        </React.Fragment>
    );
};

export { CustomRadial, GradientChart }